"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const hauling_1 = require("./hauling");
const pit_operation_1 = require("./pit-operation");
const hauling_statistic_1 = require("./hauling-statistic");
const operator_attendance_1 = require("./operator-attendance");
const production_statistic_1 = require("./production-statistic");
const reportReducer = (0, redux_1.combineReducers)({
    hauling: hauling_1.haulingReducer,
    pitOperation: pit_operation_1.reportPitOperationReducer,
    haulingStatistic: hauling_statistic_1.haulingStatisticReducer,
    operatorAttendance: operator_attendance_1.operatorAttendanceReducer,
    production: production_statistic_1.productionStatisticReducer
});
exports.default = reportReducer;
